export const videoActions = {
  LOADING: "LOADING",
  GET_VIDEOS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  ERROR: "ERROR",
};
